import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Skeleton } from '@/components/ui/skeleton';
import { BarList, Thumb } from '../../../../../components/design-system/analytics';
import { SectionCard, formatNumber } from '../../../../../components/design-system/admin';
import { ProductRow, sortProducts } from '../product-performance';
import { VIZ_LINKS } from '../links';

/** The products people try most, each with how many rooms were kept with it. */
export function TopProducts({
  rows,
  loading,
  limit = 6,
  className,
}: {
  rows: ProductRow[];
  loading?: boolean;
  limit?: number;
  className?: string;
}) {
  const { t } = useTranslation();
  const top = sortProducts(rows.filter((r) => r.tries > 0), 'tries').slice(0, limit);

  return (
    <SectionCard
      title={t('VIZ_ANALYTICS.TOP_PRODUCTS.TITLE')}
      description={t('VIZ_ANALYTICS.TOP_PRODUCTS.DESCRIPTION')}
      action={
        <Link to={VIZ_LINKS.products} className="text-xs text-muted-foreground hover:text-foreground">
          {t('VIZ_ANALYTICS.COMMON.SEE_ALL')}
        </Link>
      }
      className={className}
      testId="viz-top-products"
    >
      {loading ? (
        <div className="flex flex-col gap-2">
          {[0, 1, 2, 3, 4].map((i) => (
            <Skeleton key={i} className="h-9 w-full" />
          ))}
        </div>
      ) : (
        <BarList
          emptyText={t('VIZ_ANALYTICS.TOP_PRODUCTS.EMPTY')}
          items={top.map((r) => ({
            key: r.id,
            label: r.name,
            value: r.tries,
            leading: <Thumb src={r.thumbnailPath} alt={r.name} size="xs" />,
            secondary: t('VIZ_ANALYTICS.TOP_PRODUCTS.SAVED', { count: r.downloads, formatted: formatNumber(r.downloads) }),
            href: VIZ_LINKS.products,
          }))}
        />
      )}
    </SectionCard>
  );
}
